/* Yunabi landing — planes y botones de compra compartidos por las secciones yunabi-* */
(function () {
  if (window.__yunabiLanding) return;
  window.__yunabiLanding = true;

  function forms() { return document.querySelectorAll('[data-yl-form]'); }
  function hasEasySell() { return !!(window.EASYSELL_CONFIG || window.ES_CONFIG); }

  // Tarjetas de planes informativas: al tocarlas llevan al botón de compra de su bloque
  function gotoBuy(trigger) {
    var form = trigger.closest('[data-yl-form]') || forms()[0];
    var btn = form && (form.querySelector('[data-yl-main-buy]') || form.querySelector('[data-yl-buy]'));
    if (!btn) return;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    btn.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    btn.classList.remove('is-pulse');
    void btn.offsetWidth;
    btn.classList.add('is-pulse');
    setTimeout(function () { btn.focus({ preventScroll: true }); }, reduceMotion ? 0 : 450);
  }

  // EasySell agrega el producto al carrito cada vez que se abre: quitamos antes las
  // variantes de Yunabi que ya estén ahí para que el pedido no se duplique.
  function clearOtherPlans(form) {
    var updates = {};
    (form.dataset.ylVariants || '').split(',').forEach(function (id) { if (id) updates[id] = 0; });
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inCart = cart.items.some(function (item) { return String(item.variant_id) in updates; });
        if (!inCart) return;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      })
      .catch(function () {});
  }

  var busy = false;
  function buy(trigger) {
    var form = (trigger && trigger.closest('[data-yl-form]')) || forms()[0];
    if (!form || busy) return;
    if (form.dataset.buyMode === 'easysell' && hasEasySell()) {
      busy = true;
      clearOtherPlans(form).then(function () {
        busy = false;
        window.ES_CLOSEST_FORM = form;
        form.querySelector('.yl-es-trigger').click();
      });
    } else {
      form.submit();
    }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var plan = e.target.closest('.yl-plan[data-yl-goto-buy]');
    if (plan) { e.preventDefault(); gotoBuy(plan); }
  });

  document.addEventListener('click', function (e) {
    var plan = e.target.closest('[data-yl-goto-buy]');
    if (plan) { e.preventDefault(); gotoBuy(plan); return; }

    var cta = e.target.closest('[data-yl-buy]');
    if (cta) { e.preventDefault(); buy(cta); return; }
  });

  // Carrusel: desliza con el dedo (scroll-snap), flechas, puntos, miniaturas y rotación automática
  function setupCarousel(gallery) {
    if (gallery.__ylCarousel) return;
    // data-yl-mobile-only: solo es carrusel en celular (en computador la sección usa otra animación)
    var mobileOnly = gallery.hasAttribute('data-yl-mobile-only');
    var mq = window.matchMedia('(max-width: 989px)');
    if (mobileOnly && !mq.matches) {
      if (!gallery.__ylWaiting) {
        gallery.__ylWaiting = true;
        mq.addEventListener('change', function () { if (mq.matches) setupCarousel(gallery); });
      }
      return;
    }
    gallery.__ylCarousel = true;
    var track = gallery.querySelector('[data-yl-track]');
    var slides = track ? track.querySelectorAll(':scope > :not(.is-clone)') : [];
    var count = slides.length;
    if (count < 2) { gallery.classList.add('is-single'); return; }

    var index = 0;
    var dots = gallery.querySelector('[data-yl-dots]');
    var thumbs = gallery.querySelector('[data-yl-thumbs]');
    var buttons = [];

    for (var i = 0; i < count; i++) {
      if (dots && gallery.dataset.dots === 'true') {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'yl-gallery__dot';
        dot.dataset.ylGo = i;
        dot.setAttribute('aria-label', 'Ver imagen ' + (i + 1));
        dots.appendChild(dot);
        buttons.push(dot);
      }
      if (thumbs && gallery.dataset.thumbs === 'true') {
        var source = slides[i].querySelector('img');
        var thumb = document.createElement('button');
        thumb.type = 'button';
        thumb.className = 'yl-gallery__thumb';
        thumb.dataset.ylGo = i;
        thumb.setAttribute('aria-label', 'Ver imagen ' + (i + 1));
        if (source) {
          var img = document.createElement('img');
          img.src = source.currentSrc || source.src;
          img.alt = '';
          img.loading = 'lazy';
          thumb.appendChild(img);
        }
        thumbs.appendChild(thumb);
        buttons.push(thumb);
      }
    }

    function mark() {
      buttons.forEach(function (b) { b.classList.toggle('is-active', Number(b.dataset.ylGo) === index); });
    }
    function go(i) {
      if (mobileOnly && !mq.matches) return;
      index = (i + count) % count;
      track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
      mark();
    }

    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        if (mobileOnly && !mq.matches) return;
        index = Math.round(track.scrollLeft / track.clientWidth);
        mark();
      }, 80);
    }, { passive: true });

    gallery.addEventListener('click', function (e) {
      if (e.target.closest('[data-yl-prev]')) { go(index - 1); restart(); }
      else if (e.target.closest('[data-yl-next]')) { go(index + 1); restart(); }
      else {
        var target = e.target.closest('[data-yl-go]');
        if (target) { go(Number(target.dataset.ylGo)); restart(); }
      }
    });

    // Rotación automática: se pausa mientras el cliente interactúa o la pestaña no está visible
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = gallery.dataset.autoplay === 'true' && !reduceMotion;
    var delay = (parseFloat(gallery.dataset.speed) || 4) * 1000;
    var timer = null;
    var paused = false;
    function start() { if (!autoplay || timer) return; timer = setInterval(function () { if (!paused && !document.hidden) go(index + 1); }, delay); }
    function stop() { clearInterval(timer); timer = null; }
    function restart() { stop(); start(); }
    gallery.addEventListener('mouseenter', function () { paused = true; });
    gallery.addEventListener('mouseleave', function () { paused = false; });
    gallery.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    gallery.addEventListener('touchend', function () { setTimeout(function () { paused = false; }, 3000); }, { passive: true });

    mark();
    start();
  }

  // Testimonios: el del centro grande y los de los lados pequeños; rotan solos
  function setupCoverflow(box) {
    if (box.__ylCoverflow || box.dataset.ylCoverflow !== 'true') return;
    box.__ylCoverflow = true;
    var items = Array.prototype.slice.call(box.querySelectorAll('[data-yl-cf-item]'));
    var count = items.length;
    if (count < 2) return;
    var current = Math.floor(count / 2);
    var delay = (parseFloat(box.dataset.speed) || 4) * 1000;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = box.dataset.autoplay === 'true' && !reduceMotion;
    var paused = false;

    function render() {
      items.forEach(function (item, i) {
        var d = (i - current + count) % count;
        if (d > count / 2) d -= count;
        item.classList.remove('is-center', 'is-left', 'is-right', 'is-hidden');
        item.classList.add(d === 0 ? 'is-center' : d === -1 ? 'is-left' : d === 1 ? 'is-right' : 'is-hidden');
        item.setAttribute('aria-hidden', d === 0 ? 'false' : 'true');
        var video = item.querySelector('video');
        if (video && d !== 0 && !video.paused && !video.muted) video.pause();
      });
    }
    function go(i) { current = (i + count) % count; render(); }
    function playing() {
      return items.some(function (item) { var v = item.querySelector('video'); return v && !v.paused && !v.muted; });
    }

    box.addEventListener('click', function (e) {
      var item = e.target.closest('[data-yl-cf-item]');
      if (!item || item.classList.contains('is-center')) return;
      e.preventDefault();
      go(items.indexOf(item));
    }, true);
    box.addEventListener('mouseenter', function () { paused = true; });
    box.addEventListener('mouseleave', function () { paused = false; });
    box.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    box.addEventListener('touchend', function () { setTimeout(function () { paused = false; }, 3000); }, { passive: true });

    // Deslizar con el dedo
    var startX = null;
    box.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) go(current + (dx < 0 ? 1 : -1));
      startX = null;
    }, { passive: true });

    render();
    if (autoplay) {
      setInterval(function () { if (!paused && !document.hidden && !playing()) go(current + 1); }, delay);
    }
  }

  function initCarousels(root) {
    (root || document).querySelectorAll('[data-yl-carousel]').forEach(setupCarousel);
    (root || document).querySelectorAll('[data-yl-coverflow]').forEach(setupCoverflow);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-yl-form]');
    if (form && form.dataset.buyMode === 'easysell' && hasEasySell()) {
      e.preventDefault();
      buy(form.querySelector('[data-yl-buy]'));
    }
  });

  function init() {
    initCarousels();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { init(); initCarousels(e.target); });
})();
